import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { CartProvider } from "@/lib/cart";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import HomePage from "@/pages/HomePage";
import CatalogPage from "@/pages/CatalogPage";
import ProductPage from "@/pages/ProductPage";
import CartPage from "@/pages/CartPage";
import CheckoutPage from "@/pages/CheckoutPage";
import OrderSuccessPage from "@/pages/OrderSuccessPage";
import TrackPage from "@/pages/TrackPage";
import LegalPage from "@/pages/LegalPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import "@/App.css";

function AdminRoute({ children }) {
    const token = localStorage.getItem("vvs_admin_token");
    if (!token) return <Navigate to="/admin/login" replace />;
    return children;
}

function StoreLayout({ children }) {
    return (
        <>
            <Header />
            <main className="min-h-screen">{children}</main>
            <Footer />
        </>
    );
}

export default function App() {
    return (
        <CartProvider>
            <BrowserRouter>
                <div className="App">
                    <CartDrawer />
                    <Toaster theme="dark" richColors position="top-center" />
                    <Routes>
                        <Route path="/" element={<StoreLayout><HomePage /></StoreLayout>} />
                        <Route path="/boutique" element={<StoreLayout><CatalogPage /></StoreLayout>} />
                        <Route path="/boutique/:category" element={<StoreLayout><CatalogPage /></StoreLayout>} />
                        <Route path="/produit/:slug" element={<StoreLayout><ProductPage /></StoreLayout>} />
                        <Route path="/panier" element={<StoreLayout><CartPage /></StoreLayout>} />
                        <Route path="/commande" element={<StoreLayout><CheckoutPage /></StoreLayout>} />
                        <Route path="/commande/succes" element={<StoreLayout><OrderSuccessPage /></StoreLayout>} />
                        <Route path="/suivi" element={<StoreLayout><TrackPage /></StoreLayout>} />
                        <Route path="/a-propos" element={<StoreLayout><LegalPage page="a-propos" /></StoreLayout>} />
                        <Route path="/authenticite" element={<StoreLayout><LegalPage page="authenticite" /></StoreLayout>} />
                        <Route path="/politique-de-retour" element={<StoreLayout><LegalPage page="retour" /></StoreLayout>} />
                        <Route path="/cgv" element={<StoreLayout><LegalPage page="cgv" /></StoreLayout>} />
                        <Route path="/confidentialite" element={<StoreLayout><LegalPage page="confidentialite" /></StoreLayout>} />
                        <Route path="/contact" element={<StoreLayout><ContactPage /></StoreLayout>} />
                        <Route path="/admin/login" element={<AdminLogin />} />
                        <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </div>
            </BrowserRouter>
        </CartProvider>
    );
}
